import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  menu: {
    marginTop: -10,
    '& .MuiList-root':{
        padding: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    }

  },
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    fontFamily: 'Noto Color Emoji, sans-serif'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '3px 10px',
    fontSize: 14,
    color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_500.main :  theme.palette.gray_50.main,
      borderRadius: 4,
    },
    '& svg':{
        width: 18,
        height: 18,
    }
  }
}))
